
import { Component, Watch, Mixins } from 'vue-property-decorator';
import { Drag, DropList } from 'vue-easy-dnd';

import { Widget, Widgets } from '@/features/dashboard/types';
import HowItWorks from '@/features/dashboard/components/widgets/howItWorks/index.vue';
import ShippingTips from '@/features/dashboard/components/widgets/shippingTips/index.vue';
import RecentShipments from '@/features/dashboard/components/widgets/recentShipments/index.vue';
import ScheduledPickups from '@/features/dashboard/components/widgets/scheduledPickups/index.vue';
import TransitStatus from '@/features/dashboard/components/widgets/transitStatus/index.vue';
import CostBreakdown from '@/features/dashboard/components/widgets/costBreakdown/index.vue';
// import TopChannels from '@/features/dashboard/components/widgets/topChannels/index.vue';
import TopDestinations from '@/features/dashboard/components/widgets/topDestinations/index.vue';
import CreateShipmentHint from '@/features/dashboard/components/CreateShipmentHint.vue';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { patchDashboardSetting } from '@/features/dashboard/services/dashboard.services';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    HowItWorks,
    ShippingTips,
    RecentShipments,
    ScheduledPickups,
    TransitStatus,
    // TopChannels,
    TopDestinations,
    CostBreakdown,
    CreateShipmentHint,
    Drag,
    DropList,
  },
})
export default class WidgetsWrapper extends Mixins(ResponsivenessMixin) {
  private smallWidgets: Widget[] = [];

  private bigWidgets: Widget[] = [];

  private mobileWidgets: Widget[] = [];

  get hasShipped(): boolean {
    return this.$store.getters.getHasShipped;
  }

  get widgets(): Widgets {
    return this.$store.getters.getWidgets;
  }

  get isShowWelcomeWidget(): boolean {
    return this.$store.getters.getIsShowWelcomeWidget;
  }

  get isDashboardSettings(): number {
    return this.$store.getters.getIsDashboardSettings;
  }

  get shippingTipsWidget(): Widget | undefined {
    return this.smallWidgets.find((w) => w.name === 'shippingTips');
  }

  get widgetsWithoutShippingTips(): Widget[] {
    return this.smallWidgets.filter((w) => w.name !== 'shippingTips') || [];
  }

  get tabletSmallWidgetsCol1(): Widget[] {
    return this.widgetsWithoutShippingTips.slice(
      0,
      Math.ceil(this.widgetsWithoutShippingTips.length / 2),
    );
  }

  get tabletSmallWidgetsCol2(): Widget[] {
    return this.widgetsWithoutShippingTips.slice(this.tabletSmallWidgetsCol1.length);
  }

  @Watch('isDashboardSettings', { immediate: true })
  private populateWidgets(newValue: number) {
    if (!newValue) return;

    this.bigWidgets = this.loadWidgets('big');
    this.smallWidgets = this.loadWidgets('small');
    this.mobileWidgets = this.loadWidgets('mobile');
  }

  private loadWidgets(size: 'big' | 'small' | 'mobile'): Widget[] {
    const widgetElements = Object.entries(this.widgets).map((el) => {
      return {
        ...el[1],
        key: el[0],
      };
    });

    const widgets = widgetElements.filter(
      (widget) => (size === 'mobile' && true) || (widget.show === true && widget.size === size),
    );

    if (size !== 'mobile') {
      widgets.sort((a, b) => a.position - b.position);
    }

    return widgets.map((w) => ({ ...w, name: w.key }));
  }

  private mounted() {
    eventBus.$on(eventNames.UPDATE_DASHBOARD_WIDGETS_COLUMN, this.updateWidgets);
    eventBus.$on(eventNames.SORT_DASHBOARD_WIDGETS_POSITION, this.sortWidgetsPosition);
  }

  private changePosition(size: 'big' | 'small'): void {
    const widgetType = size === 'big' ? 'bigWidgets' : 'smallWidgets';

    const order = this[widgetType].map((w) => w.name);

    this.$store.commit('updateWidgetsPosition', order);
    this.updateWidgetsPosition(size);

    patchDashboardSetting([
      {
        path: `order/${size}`,
        op: 'replace',
        value: order.map((o) => o.charAt(0).toUpperCase() + o.slice(1)),
      },
    ]);
  }

  private updateWidgetsPosition(size: 'big' | 'small'): void {
    const widgetType = size === 'big' ? 'bigWidgets' : 'smallWidgets';
    this[widgetType] = this[widgetType].map((w, i) => ({ ...w, position: i + 1 }));
  }

  private updateWidgets({ method, widgetName, size }: {
    method: 'push' | 'pop', widgetName: string, size: 'big' | 'small'
  }) {
    const column = size === 'big' ? 'bigWidgets' : 'smallWidgets';

    if (method === 'push') {
      this[column].push({ ...this.widgets[widgetName], name: widgetName });
      this.mobileWidgets.push({ ...this.widgets[widgetName], name: widgetName });
    } else {
      this[column] = this[column].filter((c) => c.name !== widgetName);
      this.mobileWidgets = this.mobileWidgets.filter((c) => c.name !== widgetName);
    }

    this.$store.dispatch('patchDashboardSetting', { size, updatePositions: false });
  }

  private sortWidgetsPosition(size: 'big' | 'small') {
    const widgetType = size === 'big' ? 'bigWidgets' : 'smallWidgets';
    this[widgetType] = this.loadWidgets(size);
  }
}
